import { Form, Input } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

const FormulaNameField: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Form.Item
      name="name"
      label={t('global:name')}
      rules={[
        {
          required: true,
          message: t('global:required-field')
        }
      ]}
    >
      <Input placeholder={t('global:name')} />
    </Form.Item>
  )
}

export default FormulaNameField
